"use client";
import { Next13ProgressBar } from "next13-progressbar";

import { NextUIProvider } from "@nextui-org/react";
import SessionProviderWrapper from "./components/SessionProviderWrapper";
import DelegatedAuthDeepLink from "./components/DelegatedAuthDeepLink";
import { RegisteredUserProvider } from "@/context/RegisteredUserContext";
export default function Providers({ children }) {
  return (
    <SessionProviderWrapper>
      <DelegatedAuthDeepLink />
      <NextUIProvider>
        <RegisteredUserProvider>
          {children}
          <Next13ProgressBar
            height="4px"
            color="rgb(30 64 175)"
            options={{ showSpinner: true }}
            showOnShallow
          />
        </RegisteredUserProvider>
      </NextUIProvider>
    </SessionProviderWrapper>
  );
}
